const ScheduleListViewHeader = (): null => null;

export default ScheduleListViewHeader;
